import { ownProjects, projectGroups } from '../data/projects';
import content from '../data/content';
import PageHeader from '../components/PageHeader';
import PageMeta from '../components/PageMeta';
import WorkCard from '../components/WorkCard';
import './Projects.css';

function Projects() {
  // Пустые группы не показываем: раздел для заказчиков появится,
  // когда в clientProjects появятся первые кейсы.
  const groups = projectGroups.filter((group) => group.items.length > 0);
  const copy = content.projects;

  return (
    <>
      <PageMeta
        title={copy.metaTitle}
        description={copy.metaDescription}
      />

      <PageHeader
        eyebrow={copy.eyebrow}
        title={copy.title}
        lead={copy.lead}
        meta={
          <>
            <span>{copy.ownProductsCount(ownProjects.length)}</span>
            <span>{copy.location}</span>
          </>
        }
      />

      <section className="section section--tight">
        <div className="container">
          {groups.map((group) => (
            <div className="project-group" key={group.id}>
              <div className="project-group__head">
                <h2 className="project-group__title">{group.title}</h2>
                <p className="project-group__desc">{group.description}</p>
              </div>

              <div className="works">
                {group.items.map((project) => (
                  <WorkCard project={project} key={project.slug} />
                ))}
              </div>
            </div>
          ))}
        </div>
      </section>
    </>
  );
}

export default Projects;
